<template>
    <div class="sidebar" :class="{ 'is-collapsed': isCollapse }" v-if="isDesktop">
        <div class="logo flex-center" @click="goHome">
            <img src="/nav_logo.png" alt="" class="sidebar-logo"/>
        </div>
        <el-menu active-text-color="#ffff" background-color="#0E0E18" text-color="#8A8AA3" :default-active="currentPath"
            class="sidebar-menu" :collapse="isCollapse" :collapse-transition="false" @select="handleSelect">
            <!-- 遍历菜单 -->
            <template v-for="(item, index) in menuList" :key="index">
                <!-- 含有子菜单 -->
                <template v-if="item.children && item.children.length > 0 && !item.meta?.hide">
                    <!-- 第一层 含有子菜单菜单 -->
                    <el-sub-menu :index="item.path">
                        <template #title>
                            <component v-if="isSvgIcon(item.meta.icon)" :is="createSvgIcon(item.meta.icon)"
                                class="icon svg-icon" />
                            <img v-else class="icon" :src="(item.meta.icon ? item.meta.icon : '')" alt="" />
                            <span>{{ item.meta.title }}</span>
                        </template>
                        <!-- 第二层 子菜单遍历 -->
                        <el-menu-item v-for="(secondItem, idx) in item.children"
                            v-show="!secondItem.meta?.hide && !secondItem.meta?.show" :key="idx"
                            :index="getFullPath(item, secondItem)">
                            <text class="item-title">
                                {{ secondItem.meta.title }}
                            </text>
                        </el-menu-item>
                    </el-sub-menu>
                </template>
                <!-- 不含子菜单 -->
                <!-- -if="!item.meta?.hide" -->
                <template v-else>
                    <el-menu-item :index="item.path">
                        <component v-if="isSvgIcon(item.meta.icon)" :is="createSvgIcon(item.meta.icon)"
                            class="icon svg-icon" />
                        <img v-else class="icon" :src="(item.meta.icon ? item.meta.icon : '')" alt="" />
                        <template #title>
                            {{
                                item.meta.title === rocket ? rocket : item.meta.title === langrage['price'] ? rocket :
                                    item.meta.title
                            }}
                            <img v-if="item.meta.title == langrage['helpCenter']" class="menu_link"
                                src="../../assets/images/center/menu_link.png" alt="" />
                        </template>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
        <!-- 联系方式 -->
        <div class="content-type">
            <div class="content-type-heading">
                <span class="content-type-title">{{ langrage.contactUs || 'Contact us' }}</span>
            </div>
            <a class="contact-item telegram">
                <span class="contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m21.5 3.5-3.2 16.1c-.24 1.2-.88 1.5-1.78.94l-4.92-3.63-2.37 2.28c-.26.26-.48.48-.98.48l.35-5 9.1-8.22c.4-.35-.09-.55-.62-.2L5.83 12.1.95 10.57c-1.06-.33-1.08-1.06.22-1.57L20.25 1.6c.88-.33 1.65.2 1.25 1.9Z" />
                    </svg>
                </span>
                <span class="contact-copy">
                    <span class="contact-label">Telegram</span>
                    <span class="contact-value">@micproxy</span>
                </span>
                <svg class="contact-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M5 12h13M13 6l6 6-6 6" />
                </svg>
            </a>
            <a class="contact-item whatsapp">
                <span class="contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 11.5a8 8 0 0 1-11.8 7.1L4 20l1.4-4A8 8 0 1 1 20 11.5Z" />
                        <path d="M8.2 8.5c.2-.4.4-.4.7-.4h.5c.2 0 .4.1.5.4l.7 1.6c.1.2.1.4-.1.6l-.5.6c.6 1.1 1.4 1.8 2.6 2.3l.6-.6c.2-.2.4-.2.6-.1l1.6.7c.3.1.4.3.4.5v.5c0 .3-.1.5-.4.7-.4.3-1 .4-1.4.3-2.8-.7-5.1-2.9-5.9-5.6-.1-.5 0-1.1.1-1.5Z" />
                    </svg>
                </span>
                <span class="contact-copy">
                    <span class="contact-label">WhatsApp</span>
                    <span class="contact-value">+852 4701 0782</span>
                </span>
                <svg class="contact-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M5 12h13M13 6l6 6-6 6" />
                </svg>
            </a>
        </div>
    </div>

    <!-- 移动端侧边栏菜单 -->
    <div class="mobile-sidebar" v-if="!isDesktop" :class="{ 'mobile-sidebar-open': mobileMenuVisible }">
        <div class="mobile-sidebar-header">
            <div class="mobile-user-profile">
                <span class="username">{{ userInfo?.user?.userName || '…' }}</span>
            </div>
            <div class="close-btn" @click="$emit('close')">×</div>
        </div>

        <div class="mobile-menu-tree">
            <div class="menu-item" v-for="item in mobileMenuItems" :key="item.id">
                <div class="menu-item-header"
                    @click="item.children && item.children.length ? toggleMenu(item.id) : handleMobileMenuItemClick(item)"
                    :class="{ 'active': !(item.children && item.children.length) && isMenuItemActive(item.path) }">
                    <span>{{ item.name }}</span>
                    <span v-if="item.children && item.children.length" class="arrow">
                        {{ expandedMenus[item.id] ? '▲' : '▼' }}
                    </span>
                </div>
                <div class="submenu" v-if="item.children && item.children.length && expandedMenus[item.id]">
                    <div class="submenu-item" v-for="child in item.children" :key="child.id"
                        @click="handleMobileMenuItemClick(child)" :class="{ 'active': isMenuItemActive(child.path) }">
                        {{ child.name }}
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile-sidebar-footer">
            <div class="wallet-info">
                <img :src="require('@/assets/images/center/Wallet_balance.png')" alt="" />
                <span>{{ langrage['balance'] }}：${{ userInfo?.user?.walletBalance ?? '…' }}</span>
            </div>
            <div class="mobile-actions">
                <div class="action-item" @click="goMessage">
                    <svg data-v-3f2a3627="" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <circle data-v-3f2a3627="" cx="12" cy="8" r="4"></circle>
                        <path data-v-3f2a3627="" d="M4 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2"></path>
                    </svg>
                    <span>{{ langrage['profile1'] }}</span>
                </div>
            </div>
            <div class="mobile-actions">
                <div class="action-item" @click="checkIn">
                    <img :src="require('@/assets/images/center/exit_login.png')" alt="" />
                    <span>{{ langrage['navbar4'] }}</span>
                </div>
            </div>
        </div>

        <!-- 联系方式 -->
        <div class="content-type">
            <div class="content-type-heading">
                <span class="content-type-title">{{ langrage.contactUs || 'Contact us' }}</span>
            </div>
            <a class="contact-item telegram">
                <span class="contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m21.5 3.5-3.2 16.1c-.24 1.2-.88 1.5-1.78.94l-4.92-3.63-2.37 2.28c-.26.26-.48.48-.98.48l.35-5 9.1-8.22c.4-.35-.09-.55-.62-.2L5.83 12.1.95 10.57c-1.06-.33-1.08-1.06.22-1.57L20.25 1.6c.88-.33 1.65.2 1.25 1.9Z" />
                    </svg>
                </span>
                <span class="contact-copy">
                    <span class="contact-label">Telegram</span>
                    <span class="contact-value">@micproxy</span>
                </span>
                <svg class="contact-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M5 12h13M13 6l6 6-6 6" />
                </svg>
            </a>
            <a class="contact-item whatsapp">
                <span class="contact-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 11.5a8 8 0 0 1-11.8 7.1L4 20l1.4-4A8 8 0 1 1 20 11.5Z" />
                        <path d="M8.2 8.5c.2-.4.4-.4.7-.4h.5c.2 0 .4.1.5.4l.7 1.6c.1.2.1.4-.1.6l-.5.6c.6 1.1 1.4 1.8 2.6 2.3l.6-.6c.2-.2.4-.2.6-.1l1.6.7c.3.1.4.3.4.5v.5c0 .3-.1.5-.4.7-.4.3-1 .4-1.4.3-2.8-.7-5.1-2.9-5.9-5.6-.1-.5 0-1.1.1-1.5Z" />
                    </svg>
                </span>
                <span class="contact-copy">
                    <span class="contact-label">WhatsApp</span>
                    <span class="contact-value">+852 4701 0782</span>
                </span>
                <svg class="contact-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M5 12h13M13 6l6 6-6 6" />
                </svg>
            </a>
        </div>
    </div>

    <!-- 移动端遮罩层 -->
    <div class="mobile-overlay" v-if="!isDesktop && mobileMenuVisible" @click="$emit('close')"></div>
</template>

<script setup>
    import {
        Document,
        Menu as IconMenu,
        Location,
        Setting
    } from '@element-plus/icons-vue';
    import {
        ref,
        inject,
        computed,
        onMounted,
        watch,
        onBeforeUnmount
    } from 'vue';
    import {
        useRoute,
        useRouter
    } from 'vue-router';
    import {
        useStore
    } from 'vuex';

    const emit = defineEmits(['close']);

    const langrage = inject('langrage');
    const store = useStore();
    const isCollapse = computed(() => store.state.sidebarOpen);
    const router = useRouter();
    const route = useRoute();
    const currentPath = ref('/');
    const userInfo = computed(() => store.state.user.userInfo);

    // 不需要展示在左侧菜单的路由
    const hideMenu = ['/login', '/register', '/resetPassword', '/confirmPassword', '/chService', '/enService',
        '/chPolicy', '/enPolicy',
    ];
    const menuList = ref([]);

    let lang = localStorage.getItem('langrage');
    // 响应式数据，用于判断是否为移动端
    const isDesktop = ref(true)
    const BREAKPOINT = 768
    // 检查屏幕宽度的函数
    const checkScreenSize = () => {
        isDesktop.value = window.innerWidth > BREAKPOINT
    }

    // 获取完整路径的函数
    const getFullPath = (parentItem, childItem) => {
        // 特殊处理帮助中心的子路由
        if (parentItem.path === '/helpCenter') {
            return `/helpCenter/${childItem.path}`;
        }
        // 其他情况保持原来的逻辑
        return parentItem.path + '/' + childItem.path;
    };

    // 监听窗口大小变化
    const handleResize = () => {
        checkScreenSize()
    }

    const goHome = () => {
        if (lang === 'english') {
            window.location.href = '/';
        }
        if (lang === 'chinese') {
            window.location.href = '/';
        }
    };

    // 处理路由
    const handleRoutes = () => {
        const {
            routes
        } = router.options;
        hideMenu.forEach((it) => {
            routes.forEach((item, index) => {
                if (it === item.path) {
                    routes.splice(index, 1);
                }
            });
        });
        // menuList.value = routes;
        //从数组中筛除"CDKEY"
        menuList.value = routes.map(route => {
            if (route.children) {
                return {
                    ...route,
                    children: route.children.filter(child => child.path !== "CDKEY")
                };
            }
            return route;
        });
    };

    // 处理菜单选择事件
    const handleSelect = (key, keyPath) => {
        console.log('Selected key:', key);
        console.log('Key path:', keyPath);

        currentPath.value = key;
        router.push({
            path: key
        });
    };

    const toDashboard = () => {
        router.push('/');
        setTimeout(() => {
            location.reload();
        }, 200);
    };

    const rocket = langrage['rocket'];

    // 判断是否为 SVG 图标（包含 SVG 标签）
    const isSvgIcon = (icon) => {
        return typeof icon === 'string' && icon.includes('<svg');
    };

    // 创建 SVG 组件
    const createSvgIcon = (svgString) => {
        return {
            template: svgString
        };
    };

    onMounted(() => {
        handleRoutes();

        console.log('path' + route.path);
        if (route.path == '/dashboard') {
            currentPath.value = `/${route.path.split('/')[0]}`;
        } else if (route.meta.hide) {
            currentPath.value = `/${route.path.split('/')[1]}`;
        } else {
            currentPath.value = route.path;
        }
        checkScreenSize()
        window.addEventListener('resize', handleResize)
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize)
    })

    const handleRouteChange = (newRoute) => {
        if (route.path == '/dashboard') {
            currentPath.value = `/${route.path.split('/')[0]}`;
        } else if (route.meta.hide) {
            currentPath.value = `/${route.path.split('/')[1]}`;
        } else {
            currentPath.value = route.path;
        }
    };

    // 监听路由变化
    watch(
        () => route,
        (newRoute) => {
            handleRouteChange(newRoute);
        }, {
            immediate: true,
            deep: true
        }
    );

    // ========== 移动端相关逻辑 ==========
    const props = defineProps({
        mobileMenuVisible: {
            type: Boolean,
            default: false
        }
    });

    // 移动端菜单数据
    const mobileMenuItems = computed(() => [{
            id: 1,
            name: langrage.center,
            path: '/dashboard',
            children: []
        },
        {
            id: 2,
            name: langrage.productNewName,
            path: '/product/price',
        },
        {
            id: 3,
            name: langrage.mobileName,
            path: '/mobility/price',
        },
        {
            id: 4,
            name: langrage.sele11,
            path: '/Infinite/InfinitePrice',
        },
        {
            id: 5,
            name: langrage.staticProduct,
            path: '/staticState/staticPrice',
        },
        {
            id: 6,
            name: langrage.New18,
            path: '/quickStart',
        },
        {
            id: 7,
            name: langrage.New54,
            path: '/account',
            children: [{
                    id: 31,
                    name: langrage.profile1,
                    path: '/account/profile'
                },
                {
                    id: 32,
                    name: langrage.billing1,
                    path: '/account/billings'
                },
                {
                    id: 34,
                    name: langrage.New81,
                    path: '/account/Union'
                }
            ]
        },
        {
            id: 8,
            name: langrage.dashboard12,
            path: '/helpCenter',
            children: [{
                    id: 61,
                    name: langrage.New15,
                    path: '/helpCenter/guide',
                },
                {
                    id: 61,
                    name: langrage.New103,
                    path: '/helpCenter/index',
                },
                {
                    id: 62,
                    name: langrage.New104,
                    path: '/helpCenter/faq',
                }
            ]
        },
    ]);

    // 移动端菜单展开状态
    const expandedMenus = ref({});

    // 切换菜单展开状态
    const toggleMenu = (id) => {
        expandedMenus.value[id] = !expandedMenus.value[id]
    };

    // 移动端菜单项点击处理
    const handleMobileMenuItemClick = (item) => {
        router.push(item.path);
        emit('close');
    };

    // 判断菜单项是否激活
    const isMenuItemActive = (itemPath) => {
        return route.path === itemPath || route.path.startsWith(itemPath + '/');
    };

    // 跳转到消息页面
    const goMessage = () => {
        router.push('/account/profile');
        emit('close');
    };

    // 签到处理
    const checkIn = () => {
        // 退出登录逻辑
        localStorage.removeItem('token');
        router.push('/login');
    };
</script>

<style lang="less" scoped>
    .sidebar {
        height: 100vh;
        background: #fff;
        border-right: 1px solid rgba(255, 255, 255, .06);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        padding: 18px 14px 24px;
        position: sticky;
        top: 0;
        height: 100vh;
        width: 25rem;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        z-index: 50;
        color: #FFFFFF;

        .logo {
            margin: 0 auto;
            height: 7rem;
            font-size: 3rem;
            color: #fff;
            gap: 1rem;
            transition: 0.5s;

            .sidebar-logo {
                height: 40px;
            }
        }

        .sidebar-menu {
            box-sizing: border-box;
            min-height: 0;
            flex: 1;
            height: auto;
            overflow-y: auto;
            transition: 0.5s;

            &::-webkit-scrollbar {
                width: 4px;
            }

            &::-webkit-scrollbar-thumb {
                background: rgba(255, 255, 255, .1);
                border-radius: 2px;
            }
        }

        &.is-collapsed {
            .content-type {
                padding: 10px 6px;

                .content-type-heading {
                    justify-content: center;
                }

                .contact-item {
                    justify-content: center;
                    padding: 8px;

                    .contact-copy,
                    .contact-arrow {
                        display: none;
                    }
                }
            }
        }

        .icon {
            width: 18px;
            height: 18px;
            color: rgba(128, 137, 168, 1);
            margin-right: 11px;
            transition: color 0.2s;
            flex-shrink: 0;
        }

        .svg-icon {
            fill: currentColor;
        }

        .menu_link {
            position: absolute;
            right: 2.4rem;
            width: 2.4rem;
        }

        .item-title {
            padding-left: 0;
        }
    }

    ::v-deep {
        .el-menu {
            border-right: none;
            background: transparent;
        }

        .el-sub-menu {
            margin-bottom: 6px;

            .el-sub-menu__title {
                display: flex;
                align-items: center;
                padding: 10px 12px;
                border-radius: 9px;
                color: #2B3340;
                font-size: 14px;
                font-weight: 500;
                transition: all 0.2s;
                cursor: pointer;
                border: 1px solid transparent;

                &:hover {
                    background: rgba(43, 127, 255, .08);
                    font-weight: 600;
                    .icon {
                        color: rgba(74, 158, 255, 1);
                    }
                }
            }

            &.is-active {
                .el-sub-menu__title {
                    background: #eaecf1;
                    color: #000;
                    font-weight: 600;

                    .icon {
                        color: rgba(74, 158, 255, 1);
                    }
                }
            }
        }

        .el-menu-item {
            display: flex;
            align-items: center;
            color: #2B3340;
            font-size: 14px;
            font-weight: 500;
            border-radius: 9px;
            transition: all 0.2s;
            cursor: pointer;
            text-align: left;
            padding: 0 12px 0 42px;
            border: 1px solid transparent;

            &:hover {
                background: rgba(43, 127, 255, .08);
                font-weight: 600;
            }

            &.is-active {
                background: #0F1117;
                color: #fff;
                font-weight: 600;
            }
        }

        .el-menu-item .el-menu-tooltip__trigger {
            padding: 2rem;
        }
    }

    .flex-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .content-type {
        flex: 0 0 auto;
        margin: 0 -6px;
        padding: 17px 4px 48px;
        border-top: 1px solid #e8ebf2;
        background: #fff;
    }

    .content-type-heading {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        padding: 0 4px;
    }

    .content-type-title {
        flex: 0 0 auto;
        color: #7b8495;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.1em;
        line-height: 1;
        text-transform: uppercase;
    }

    .contact-item {
        display: flex;
        min-width: 0;
        align-items: center;
        gap: 10px;
        margin-bottom: 7px;
        border: 1px solid transparent;
        border-radius: 12px;
        color: #334155;
        text-decoration: none;
        transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;

        &:hover {
            background: #f5f9ff;
            transform: translateX(2px);
        }
    }

    .contact-icon {
        display: inline-flex;
        width: 35px;
        height: 35px;
        flex: 0 0 35px;
        align-items: center;
        justify-content: center;
        border-radius: 11px;
        color: #fff;

        svg {
            width: 19px;
            height: 19px;
        }
    }

    .contact-item.telegram .contact-icon {
        background: linear-gradient(145deg, #40a9ff, #2276d2);
        box-shadow: 0 5px 12px rgba(34, 118, 210, 0.2);
    }

    .contact-item.whatsapp .contact-icon {
        background: linear-gradient(145deg, #35cf86, #149b61);
        box-shadow: 0 5px 12px rgba(20, 155, 97, 0.18);
    }

    .contact-copy {
        display: flex;
        min-width: 0;
        flex: 1;
        flex-direction: column;
        gap: 3px;
    }

    .contact-label {
        color: #7d8798;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.04em;
        line-height: 1.1;
        text-transform: uppercase;
    }

    .contact-value {
        color: #263246;
        font-size: 14px;
        font-weight: 600;
        line-height: 1.2;
        overflow-wrap: anywhere;
    }

    .contact-arrow {
        width: 17px;
        height: 17px;
        flex: 0 0 17px;
        color: #9ba7b8;
        transition: transform 0.2s ease, color 0.2s ease;
    }

    .contact-item:hover .contact-arrow {
        color: #297ee5;
        transform: translateX(2px);
    }

    .el-menu-item:hover {
    }

    /* ============== RESPONSIVE - 移动端 (max-width: 768px) ============== */
    @media screen and (max-width: 768px) {
        .sidebar {
            display: none !important;
        }

        .mobile-sidebar {
            position: fixed;
            top: 0;
            left: -280px;
            width: 280px;
            height: 100vh;
            background: linear-gradient(180deg, rgb(52 54 59 / 85%) 0%, rgb(0 0 0 / 85%) 100%);
            border-right: 1px solid rgba(255, 255, 255, .06);
            backdrop-filter: blur(20px);
            -webkit-backdrop-filter: blur(20px);
            box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);
            z-index: 999;
            transition: left 0.3s cubic-bezier(0.22, 1, 0.36, 1);
            display: flex;
            flex-direction: column;

            &.mobile-sidebar-open {
                left: 0;
            }

            .mobile-sidebar-header {
                padding: 18px 22px;
                border-bottom: 1px solid rgba(255, 255, 255, .06);
                background: transparent;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .mobile-user-profile {
                    display: flex;
                    align-items: center;
                    gap: 12px;

                    .avatar {
                        width: 44px;
                        height: 44px;
                        border-radius: 12px;
                        border: 2px solid rgba(43, 127, 255, .3);
                    }

                    .username {
                        font-size: 15px;
                        font-weight: 600;
                        color: #FFFFFF;
                    }
                }

                .close-btn {
                    font-size: 24px;
                    color: rgba(255, 255, 255, 0.6);
                    cursor: pointer;
                    transition: color 0.2s;

                    &:hover {
                        color: #FFFFFF;
                    }
                }
            }

            .mobile-menu-tree {
                padding: 18px 14px 24px;
                flex: 1;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 4px;
                }

                &::-webkit-scrollbar-thumb {
                    background: rgba(255, 255, 255, .1);
                    border-radius: 2px;
                }

                .menu-item {
                    margin-bottom: 6px;

                    .menu-item-header {
                        padding: 10px 12px;
                        display: flex;
                        align-items: center;
                        gap: 11px;
                        color: rgba(180, 188, 208, 1);
                        font-size: 14px;
                        font-weight: 500;
                        transition: all 0.2s;
                        cursor: pointer;
                        border-radius: 9px;
                        border: 1px solid transparent;

                        &:hover {
                            background: rgba(43, 127, 255, .08);
                            color: #FFFFFF;
                        }

                        &.active {
                            background: linear-gradient(135deg, rgba(43, 127, 255, .18), rgba(43, 127, 255, .06));
                            color: #fff;
                            border-color: rgba(43, 127, 255, .3);
                            font-weight: 600;
                        }

                        .arrow {
                            margin-left: auto;
                            font-size: 10px;
                            color: rgba(92, 101, 132, 1);
                        }
                    }

                    .submenu {
                        background: rgba(43, 127, 255, .05);

                        .submenu-item {
                            padding: 10px 12px 10px 42px;
                            color: rgba(128, 137, 168, 1);
                            font-size: 13.5px;
                            cursor: pointer;
                            transition: all 0.2s;

                            &:hover {
                                background: rgba(43, 127, 255, .08);
                                color: #FFFFFF;
                            }

                            &.active {
                                color: rgba(74, 158, 255, 1);
                                font-weight: 600;
                                background: rgba(43, 127, 255, .08);
                            }
                        }
                    }
                }
            }

            .mobile-sidebar-footer {
                border-top: 1px solid rgba(255, 255, 255, .06);
                padding: 14px;
                background: rgba(5, 11, 30, .6);

                .wallet-info {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 12px;
                    background: linear-gradient(160deg, rgba(43, 127, 255, .18) 0%, rgba(37, 224, 240, .08) 100%);
                    border: 1px solid rgba(43, 127, 255, .3);
                    border-radius: 12px;
                    margin-bottom: 12px;

                    img {
                        width: 20px;
                        height: 20px;
                        filter: brightness(0) invert(1);
                        opacity: 0.8;
                    }

                    span {
                        font-size: 13px;
                        color: #FFFFFF;
                    }
                }

                .mobile-actions {
                    padding: 8px 0;

                    .action-item {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        padding: 10px 12px;
                        border-radius: 9px;
                        cursor: pointer;
                        transition: background 0.2s;

                        &:hover {
                            background: rgba(43, 127, 255, .08);
                            color: #FFFFFF;
                        }

                        svg, img {
                            width: 18px;
                            height: 18px;
                            filter: brightness(0) invert(1);
                            opacity: 0.7;
                        }

                        span {
                            font-size: 14px;
                            color: rgba(255, 255, 255, 0.8);
                        }
                    }
                }
            }

            .content-type {
                margin-top: 0;
                margin-right: 0;
                margin-left: 0;
                padding: 16px 17px 19px;
                border-top: 1px solid rgba(255, 255, 255, .08);
                background: rgba(5, 11, 30, .82);

                .content-type-heading {
                    margin-bottom: 9px;
                    padding: 0 4px;
                }

                .content-type-title {
                    color: rgba(255, 255, 255, .5);
                }

                .contact-item {
                    margin-bottom: 6px;
                    padding: 10px;
                    color: #fff;

                    &:hover {
                        border-color: rgba(43, 127, 255, .28);
                        background: rgba(43, 127, 255, .1);
                        transform: none;
                    }
                }

                .contact-label {
                    color: rgba(255, 255, 255, .48);
                }

                .contact-value {
                    color: rgba(255, 255, 255, .88);
                }

                .contact-arrow {
                    color: rgba(255, 255, 255, .4);
                }
            }
        }

        .mobile-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            backdrop-filter: blur(4px);
            z-index: 998;
            transition: opacity 0.3s;
        }
    }
</style>
